import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import TopPlayersProxy from './proxy'

class TopPlayersService extends ServiceBase {
  getTopPlayersTable(params) {
    return this.getData(() => TopPlayersProxy.getTopPlayersTable(params))
  }
  downloadTopPlayers(params) {
    return this.getFileDownload(() =>
      TopPlayersProxy.downloadTopPlayers(params),
    )
  }
  getTopYear(params) {
    return this.getData(() => TopPlayersProxy.getTopYear(params))
  }
}

export default new TopPlayersService()
